// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2sM7_","icon":"style_icon__3jbtr"};